export enum TCI_EVAL_STATE {
    /**
     *  The field is visible based on the bit flag
     * @type {number}
     */
    EVAL_VISIBLE = 0x2,
    /**
     * The field is enabled based on the bit flag
     * @type {number}
     */
    EVAL_ENABLED = 0x4,
    /**
     * The field is valid based on the bit flag
     * @type {number}
     */
    EVAL_VALID = 0x8,
}

/**
 * Enabled
 */
export interface ITCIEvalEnabled {
    enabled: boolean;
}

/**
 * Visible
 */
export interface ITCIEvalVisible {
    visible: boolean;
}

/**
 * Valid
 */
export interface ITCIEvalValid {
    valid: boolean;
}

/**
 * Eval State
 */
export interface ITCIEvalState extends ITCIEvalEnabled, ITCIEvalValid, ITCIEvalVisible {
}

/**
 * Generic Eval Context
 */
export interface ITCIEvalContext {
    [prop: string]: any;
}


/**
 * Evaluation Result
 */
export interface ITCIEvalResult {
    /**
     * Returns Result Code
     * @return {string}
     */
    getEvalState(): ITCIEvalState;

    /**
     * Returns Result Message
     * @return {string}
     */
    getResultMessage(): string;

    /**
     * Returns a string representation of the Result
     * @return {string}
     */
    toString(): string;

    /**
     * return evalcontext
     */
    getContext(): ITCIEvalContext;

    /**
     * is visible
     */
    isVisible(): boolean;

    /**
     * is enabled
     */
    isEnabled(): boolean;

    /**
     * is valid
     */
    isValid(): boolean;

    /**
     * set visible
     * @param res
     */
    setVisible(res: boolean): ITCIEvalResult;

    /**
     * set enabled
     * @param res
     */
    setEnabled(res: boolean): ITCIEvalResult;

    /**
     * set Valid
     * @param res
     */
    setValid(res: boolean): ITCIEvalResult;

}

/**
 *
 */
// export interface ITCIEvalAction {
//     /**
//      * evaluate
//      * @param input
//      */
//     evaluate(input: ITCIEvalContext): ITCIEvalResult;
// }

export type TCI_EVAL_ACTION = (input: ITCIEvalContext) => ITCIEvalResult;

/**
 * class TCIEvalResult
 */
export class TCIEvalResult implements ITCIEvalResult {

    /**
     * constructor
     * @param eval context
     * @param eval resultMsg
     * @private
     */
    private constructor(private context: ITCIEvalContext, private resultMsg?: string) {
        this.context = context;
    }

    /**
     * internal state
     * @private
     */
    private state: number;

    /**
     * Static constructor
     * @param context
     * @param resultMsg
     */
    public static newResult(context: ITCIEvalContext, resultMsg?: string) {
        return new TCIEvalResult(context, resultMsg);
    }
    /**
     * Static constructor
     * @param context
     * @param resultMsg
     */
    public static newResultFromState(context: ITCIEvalContext, evalState: ITCIEvalState,  resultMsg?: string) {
        const res = new TCIEvalResult(context, resultMsg);
        res.setEnabled(evalState && evalState.enabled );
        res.setVisible(evalState && evalState.visible );
        res.setValid(evalState && evalState.valid );
        return res;
    }

    getEvalState(): ITCIEvalState {
        return {
            enabled: this.isEnabled(),
            visible: this.isVisible(),
            valid: this.isValid()
        } as ITCIEvalState;
    }

    getResultMessage(): string {
        return "";
    }

    getContext(): ITCIEvalContext {
        return this.context;
    }

    // tslint:disable:no-bitwise

    isVisible(): boolean {
        return ((this.state & TCI_EVAL_STATE.EVAL_VISIBLE) === TCI_EVAL_STATE.EVAL_VISIBLE);
    }

    isEnabled(): boolean {
        return ((this.state & TCI_EVAL_STATE.EVAL_ENABLED) === TCI_EVAL_STATE.EVAL_ENABLED);
    }

    isValid(): boolean {
        return ((this.state & TCI_EVAL_STATE.EVAL_VALID) === TCI_EVAL_STATE.EVAL_VALID);
    }

    setVisible(res: boolean): ITCIEvalResult {
        this.state = res ? this.state | TCI_EVAL_STATE.EVAL_VISIBLE : this.state & ~TCI_EVAL_STATE.EVAL_VISIBLE;
        return this;
    }

    setEnabled(res: boolean): ITCIEvalResult {
        this.state = res ? this.state | TCI_EVAL_STATE.EVAL_ENABLED : this.state & ~TCI_EVAL_STATE.EVAL_ENABLED;
        return this;
    }

    setValid(res: boolean): ITCIEvalResult {
        this.state = res ? this.state | TCI_EVAL_STATE.EVAL_VALID : this.state & ~TCI_EVAL_STATE.EVAL_VALID;
        return this;
    }

    toString(): string {
        const str = `context: ${this.context.toString()} visible:${this.isVisible()} enabled: ${this.isEnabled()} valid: ${this.isValid()}`;
        return this.resultMsg ? `${str} msg: ${this.resultMsg}` : str;
    }

}


